<template>
	<main>
        <HeaderTab 
            :title="$t('horse.mouvements')"   
        />

		<div id="content">
			<div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="box">
							<DateRange
					            :start.sync="start_date"
					            :end.sync="end_date"
					            @submit="load_mouvements"
				        	/>
					        <LoadingSpinner v-if="loading" />
					        <div v-else-if="mouvements" id="marelist">
					        	<div class="row mares">
									<div class="col-2">{{ $t('mouvement.mouvement_horse') }}</div>
									<div class="col-1">{{ $t('mouvement.mouvement_date') }}</div>
									<div class="col-2">{{ $t('mouvement.mouvement_label') }}</div>
									<div class="col-2">{{ $t('mouvement.mouvement_adresse') }}</div>
									<div class="col-1">{{ $t('mouvement.mouvement_cp') }}</div>
									<div class="col-2">{{ $t('mouvement.mouvement_ville') }}</div>
									<div class="col-2">{{ $t('mouvement.mouvement_raison') }}</div>
					        	</div>
								<div class="row mares mt-1" v-for="mouvement in mouvements" :key="mouvement.mouvement_id">
									<div class="col-2"><router-link :to="{ name: 'horseFiche', params: { horse_id: mouvement.horse_id }}">{{ mouvement.horse_mouvement }}</router-link></div>
									<div class="col-1">
										<font-awesome-icon style="color: green;" v-if="mouvement.mouvement_type == 1" :icon="['fal', 'sign-in-alt']" />
										<font-awesome-icon style="color: blue;" v-else-if="mouvement.mouvement_type == 5" :icon="['fal', 'farm']" />
										<font-awesome-icon style="color: red;" v-else :icon="['fal', 'sign-out-alt']" />
										{{ formatDate(mouvement.mouvement_date) }}
									</div>
									<div class="col-2">{{ mouvement.mouvement_label }}</div>
									<div class="col-2">{{ mouvement.mouvement_adresse }}</div>
									<div class="col-1">{{ mouvement.mouvement_cp }}</div>
									<div class="col-2">{{ mouvement.mouvement_ville }}</div>
									<div class="col-2">{{ mouvement.mouvement_raison }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
	import Horse from '@/mixins/Horse.js'

	export default {
		name: 'Mouvements',
		mixins: [Horse],
		data () {
			return {
				loading: false,
				mouvements: [],
				start_date: new Date(new Date().setMonth(new Date().getMonth() - 1)),
				end_date: new Date()
			}
		},

		methods: {
			async load_mouvements() {
				this.loading = true
				this.mouvements = await this.getMouvements(this.start_date, this.end_date)
				this.loading = false
			},
		},

		components: {
            LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
            DateRange: () => import('GroomyRoot/components/Inputs/DateRange'),
            HeaderTab: () => import('GroomyRoot/components/HeaderTab')
		}
	}

</script>